module.exports = __webpack_public_path__ + "img/vessel_kline_wide.6a743501.jpg";